import {
  Button,
  CardContent,
  Grid,
  Snackbar,
  TextField,
  Tabs,
  Tab,
} from "@material-ui/core";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Alert, Autocomplete, ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { AgGridReact } from "ag-grid-react";
import React, {
  useEffect,
  useRef,
  useMemo,
  useState,
} from "react";
import api from "../../utils/api";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 645,
    backgroundImage:
      "linear-gradient(to right, rgba(00, 92, 73,1), rgb(10, 36, 26))",
  },
  table: {
    minWidth: 500,
    height: 300,
    overflowY: "auto",
  },
  paperContainer1: {
    backgroundImage: `linear-gradient(to right bottom, rgba(255,255,255,.1), rgba(255,255,255,.1)), url(${require("../../assets/img/topBack.jpg")})`,
    backgroundPosition: "0,0",
    backgroundColor: "#174C38",
    padding: "20px",
    marginBottom: 20,
    "@media screen and (max-width: 576px)": {
      padding: 10,
    },
  },
  GridContainer: {
    minHeight: 356,
    minWidth: 900,
    backgroundPosition: "0,0",
    marginBottom: 20,
  },
  textSecondary: {
    color: "#ffffff",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  memeberGrid: {
    display: "grid",
    gap: 10,
    gridTemplateColumns: "1fr",
    "@media screen and (max-width: 576px)": {
      gridTemplateColumns: "1fr",
    },
  },
  tabsRoot: {
    backgroundColor: '#e0e0e0',
    borderRadius: theme.shape.borderRadius,
    minHeight: 48,
  },
  tabRoot: {
    fontWeight: 'bold',
    color: '#333',
    minWidth: 120,
    '&$tabSelected': {
      color: theme.palette.primary.main,
    },
  },
  tabSelected: {},

  tabsIndicator: {
    backgroundColor: theme.palette.primary.main,
  },
}));

const LocationMasterContent = () => {
  const classes = useStyles();
  const gridRef = useRef();
  let gridApi = React.useRef(null);
  const APIBASE_URL = useMemo(() => process.env.REACT_APP_APIBASE_URL, []);

  const [locationDetails, setLocationDetails] = useState({
    UNLOCCODE: "",
    City: "",
    StateProvince: "",
    CountryCode: "",
    LocationType: "Origin",
  });
  const [carrierMasterList, setLocationMasterList] = useState([]);
  const [open, setOpen] = useState(false);
  const [succMsg, setSuccMsg] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [severity, setSeverity] = useState("success");
  const [locationOptions, setLocationOptions] = useState([]);
  const [selectedUNLocation, setSelectedUNLocation] = useState(null);

  const columns = [
    {
      field: "UNLoCode",
      headerName: "UNLocode",
    },
    {
      field: "City",
      headerName: "City",
    },
    {
      field: "StateProvince",
      headerName: "State Province",
    },
    {
      field: "Country",
      headerName: "Country Code",
    }
  ];

  const fetchLocations = async (input) => {
    const response = await api.get(
      `${APIBASE_URL}/getUNLocations?Startswith=${input}`
    );
    setLocationOptions(response.data);
  };
  const handleLocationChange = (e) => {
    setLocationDetails({ ...locationDetails, [e.target.name]: e.target.value });
  };
  const addUNLocation = () => {
    const payLoad = {
      UNLOCCODE: selectedUNLocation.UNLocode,
      City: selectedUNLocation.City,
      StateId: selectedUNLocation.StateProvince,
      CountryCode: selectedUNLocation.CountryCode,
      LocationType: locationDetails.LocationType,
    };
    api.post(`${APIBASE_URL}/insertUNLocations`, payLoad)
      .then((res) => {
        setOpen(true);
        if (res.data === 1) {
          setSuccMsg("Origin inserted succesfully");
          setSeverity("success");
        } else if (res.data === 2) {
          setSuccMsg("Destination inserted succesfully");
          setSeverity("success");
        }
        if (res.data === 3) {
          setSuccMsg("Origin already exist");
          setSeverity("warning");
        }
        if (res.data === 4) {
          setSuccMsg("Destination already exist");
          setSeverity("warning");
        } else {
          console.log(
            "something went wrong while saving users. Please try later!"
          );
        }
      })
      .catch((err) => {
        setSuccMsg("Failed to add location");
        setSeverity("error");
        setOpen(true);
      });

  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const type = activeTab === 0 ? "O" : "D";
        const response = await api.get(`${APIBASE_URL}/GreenLocations?LocType=${type}`);
        setLocationMasterList(response.data);
      } catch (error) {
        console.error("Error fetching location data:", error.message || error);
        setLocationMasterList([]);
      }
    };
    fetchData();
  }, [activeTab]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  return (
    <div className="member-details">
      <Card className={classes.paperContainer1}>
        <div
          style={{
            backgroundColor: "#fff",
            padding: 8,
            marginBottom: 10,
            borderRadius: 4,
          }}
        >
          <Typography variant="h5" component="h2" align="center">
            Location Master
          </Typography>
        </div>
        <div style={{ backgroundColor: "#fff", padding: 10, marginBottom: 15, borderRadius: 4 }}>
          <Grid container spacing={1}>
            <Grid item sm={3}>
              <ToggleButtonGroup
                value={locationDetails.LocationType}
                exclusive
                onChange={(e, newValue) => {
                  if (newValue !== null) {
                    handleLocationChange({
                      target: { name: "LocationType", value: newValue },
                    });
                  }
                }}
                size="small"
              >
                <ToggleButton value="Origin">Origin</ToggleButton>
                <ToggleButton value="Destination">Destination</ToggleButton>
              </ToggleButtonGroup>
            </Grid>
            <Grid item sm={4}>
              <Autocomplete
                options={locationOptions}
                getOptionLabel={(option) =>
                  option.City && option.UNLocode
                    ? `${option.City} - [${option.UNLocode}]`
                    : ""
                }
                onInputChange={(event, value) => {
                  if (value.length >= 3) {
                    fetchLocations(value);
                  }
                }}
                onChange={(event, value) => {
                  setSelectedUNLocation(value);
                  handleLocationChange({
                    target: { name: locationDetails.LocationType, value: value?.value },
                  })
                }
                }
                renderInput={(params) => (
                  <TextField {...params} label={`${locationDetails.LocationType} Location`} />
                )}
                value={selectedUNLocation}
              />
            </Grid>
            <Grid item sm={3}><Button variant="contained" color="primary" onClick={addUNLocation} style={{ marginRight: 10 }}>Add location</Button></Grid>
          </Grid>
        </div>
        <Tabs value={activeTab} onChange={handleTabChange} indicatorColor="primary" textColor="primary" classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }} centered>
          <Tab label="Origin" />
          <Tab label="Destination" />
        </Tabs>
        <div className={classes.memeberGrid}>
          <Card>
            <CardContent>
              <div className="example-header">
                Page Size:
                <select onChange={(e) => gridRef.current.api.paginationSetPageSize(Number(e.target.value))} id="page-size" style={{ marginLeft: 10 }}>
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
              </div>
              <div style={{ height: 475, maxWidth: "100%", overflowX: "auto" }} className="ag-theme-alpine">
                <AgGridReact
                  ref={gridRef}
                  columnDefs={columns}
                  rowData={carrierMasterList}
                  rowSelection="multiple"
                  defaultColDef={{ resizable: true, sortable: true, filter: "agTextColumnFilter" }}
                  pagination={true}
                  paginationPageSize={50}
                  onGridReady={(params) => { gridApi.current = params.api; params.api.sizeColumnsToFit(); }}
                />
              </div>
            </CardContent>
          </Card>
        </div>
      </Card>
      <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)}>
        <Alert onClose={() => setOpen(false)} severity={severity} sx={{ width: "100%" }}>{succMsg}</Alert>
      </Snackbar>
    </div>
  );
};

export default LocationMasterContent;